export default __webpack_public_path__ + "5935f3730a81e71d459445b7a09692a9.png";